/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Faq_2_QuestionInputs */

const en_svc_rag_faq_2_question = /** @type {(inputs: Svc_Rag_Faq_2_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which documents and systems can it use?`)
};

const lv_svc_rag_faq_2_question = /** @type {(inputs: Svc_Rag_Faq_2_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kādus dokumentus un sistēmas tā var izmantot?`)
};

/**
* | output |
* | --- |
* | "Which documents and systems can it use?" |
*
* @param {Svc_Rag_Faq_2_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_faq_2_question = /** @type {((inputs?: Svc_Rag_Faq_2_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Faq_2_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_faq_2_question(inputs)
	return en_svc_rag_faq_2_question(inputs)
});